import {
  type IPayout,
  type IPayout2,
  type PayoutRefund,
  PayoutStatus,
} from "@gen/app-query";

export const payoutStatusLabels: Record<PayoutStatus, string> = {
  [PayoutStatus.Pending]: "Pending",
  [PayoutStatus.Completed]: "Completed",
  [PayoutStatus.Failed]: "Failed",
  [PayoutStatus.Canceled]: "Canceled",
};

export const payoutStatusColors: Record<
  PayoutStatus,
  "info" | "success" | "error"
> = {
  [PayoutStatus.Pending]: "info",
  [PayoutStatus.Completed]: "success",
  [PayoutStatus.Failed]: "error",
  [PayoutStatus.Canceled]: "error",
};

// The admin payout nests the amount and IDs under `payout_summary` while the
// client one keeps them flat, so the two shapes are told apart the way
// `isAdminTransaction` does it — by a key only one of them has.
export function isAdminPayout(payout: IPayout | IPayout2): payout is IPayout2 {
  return "payout_summary" in payout;
}

export function formatPayoutDate(date: Date, locale: string, timeZone: string) {
  return date.toLocaleDateString(locale, {
    timeZone,
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// A refund is stored as a positive amount, and when it also returns fees, the
// fees come out of the platform's balance rather than the seller's, which its
// negative accrual net delta records. The payout is therefore only reduced by
// the refund amount plus the accrual net delta, i.e. the amount of the transfer
// reversal, which is returned as a negative number because it's deducted from
// the payout.
export function getPayoutRefundAmount(payoutRefund: PayoutRefund): number {
  return -(
    payoutRefund.refund.amount + (payoutRefund.refund.accrual_net_delta ?? 0)
  );
}
